"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DealsSection;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _uawBase = _interopRequireDefault(require("../../../elements/widgets/universal-ad-widget/uaw-base.js"));
/**
 * DealsSection
 * @module DealsSection
 *
 * @param {Object} props React props
 * @param {string} props.invert invert
 * @param {String} props.partial Theme partial
 * @param {string} props.backgroundColor Background color section
 * @param {Object} props.listItem List items
 * @returns {React.ReactElement} DealsSection Component
 * @public
 */

function DealsSection({
  adPlacementKey,
  universalAdWidgetConfig,
  ...headlineProps
}) {
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    dataCy: "deals-section"
  }, /*#__PURE__*/_react.default.createElement(_index.default, headlineProps), /*#__PURE__*/_react.default.createElement(_uawBase.default, {
    adPlacementKey: adPlacementKey,
    universalAdWidgetConfig: universalAdWidgetConfig
  }));
}
DealsSection.propTypes = {
  adPlacementKey: _propTypes.default.string.isRequired,
  // The ad placement key to fetch ads for
  universalAdWidgetConfig: _propTypes.default.object,
  ..._index.default.propTypes
};